import { getPrivateApi } from "../lib/axiosConfig";

const api = getPrivateApi();
const endpoint = "/washing-types"

export const getWashingTypes = async () => {

  try {
    const { data } = await api.get(`${endpoint}`)

    return {
      success: true,
      response: data
    };
  } catch (error: any) {
    const errMsg = "Erro ao buscar tipos de lavagem";

    console.error(errMsg, error?.response ?? error);
    
    const message = error?.response?.data?.message ?? errMsg;
    
    throw new Error(message);
  };
}
